import { render, staticRenderFns } from "./CohortsClear.vue?vue&type=template&id=49780a4d&scoped=true"
import script from "./CohortsClear.vue?vue&type=script&lang=js"
export * from "./CohortsClear.vue?vue&type=script&lang=js"
import style0 from "./CohortsClear.vue?vue&type=style&index=0&id=49780a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49780a4d",
  null
  
)

export default component.exports